import { useCallback, useState } from "react";

function toPaginationModelKey(paginationStateId) {
  return `Pagination_PaginationModel_${paginationStateId}`;
}

function toSortModelKey(paginationStateId) {
  return `Pagination_SortModel_${paginationStateId}`;
}

function toFilterModelKey(paginationStateId) {
  return `Pagination_FilterModel_${paginationStateId}`;
}

function _savePersistedState(paginationStateId, paginationModel, sortModel, filterModel) {
  if (!paginationStateId) {
    return;
  }

  if (paginationModel) {
    const key = toPaginationModelKey(paginationStateId);
    sessionStorage.setItem(key, JSON.stringify(paginationModel));
  }

  if (sortModel) {
    const key = toSortModelKey(paginationStateId);
    sessionStorage.setItem(key, JSON.stringify(sortModel));
  }

  if (filterModel) {
    const key = toFilterModelKey(paginationStateId);
    sessionStorage.setItem(key, JSON.stringify(filterModel));
  }
}

function _loadPersistedState(paginationStateId) {
  if (!paginationStateId) {
    return {};
  }

  const paginationModel = JSON.parse(sessionStorage.getItem(toPaginationModelKey(paginationStateId)));
  const sortModel = JSON.parse(sessionStorage.getItem(toSortModelKey(paginationStateId)));
  const filterModel = JSON.parse(sessionStorage.getItem(toFilterModelKey(paginationStateId)));

  return { paginationModel, sortModel, filterModel };
}

function _clearPersistedState(paginationStateId) {
  sessionStorage.removeItem(toPaginationModelKey(paginationStateId));
  sessionStorage.removeItem(toSortModelKey(paginationStateId));
  sessionStorage.removeItem(toFilterModelKey(paginationStateId));
}

export default function usePaginationState(paginationStateIdProp) {
  const [paginationStateId] = useState(paginationStateIdProp);

  const savePersistedState = useCallback(
    (paginationModel, sortModel, filterModel) =>
      _savePersistedState(paginationStateId, paginationModel, sortModel, filterModel),
    [paginationStateId]
  );

  const loadPersistedState = useCallback(() => _loadPersistedState(paginationStateId), [paginationStateId]);

  const clearPersistedState = useCallback(() => _clearPersistedState(paginationStateId), [paginationStateId]);

  return { savePersistedState, loadPersistedState, clearPersistedState };
}
